import '../css/VerifyEmail.css'
import { useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CircularIndeterminate from '../components/CircularLoad';
import { fetchJson } from '../utils/apiFetch';

export default function VerifyEmail(){
    const { email, token } = useParams();
    const [response, setResponse] = useState('');

    useEffect(() => {
        handleVerifyEmail(email, token);
    }, []);

    const handleVerifyEmail = async (email, token) => {
        try {
            const data = await fetchJson(`/api/auth/verify-email/${encodeURIComponent(email)}/${encodeURIComponent(token)}`, {
                method: "PUT"
            });
            setResponse(data.message || 'Email verified');
        } catch (error) {
            console.error('Error:', error);
            setResponse(error.message || 'Unable to verify email');
        }
    };

    function Copyright(props) {
        return (
          <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="/">
               Pharmacy
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
          </Typography>
        );
    }

    return (
        <section id='verifyemail-container'>
            <div id='verifyemail-box'>
            {response === '' ? (
            <CircularIndeterminate key="loading-spinner" display={true} />
            ) : (
            <>
                <h1>{response}</h1>
                {response === 'Email verified' ? (
                <CheckCircleOutlineIcon style={{ color: 'green', fontSize: '40px' }} />
                ) : (
                <HighlightOffIcon style={{ color: 'red', fontSize: '40px' }} />
                )}
            </>
            )}
            </div>
            <Copyright key="copyright" sx={{ mt: 5 }} />
            <Link color="inherit" href="/">
                <Button variant="outlined" style={{marginTop: '20px'}}>Home</Button>
            </Link>
        </section>
    )
}
